<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 분류 -->
          <c-select
            codeGroupCd="RAM_RISK_HAZARD_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramRiskHazardClassCd"
            label="분류"
            v-model="searchParam.ramRiskHazardClassCd"
            @datachange="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-text
            label="유해위험요인명"
            name="riskHazardName"
            v-model="searchParam.riskHazardName"
            @datachange="getList"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="유해위험요인 목록"
      :columns="grid.columns"
      :data="grid.data"
      gridHeightAuto
      :selection="popupParam.type"
      rowKey="ramRiskHazardId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="선택" icon="check" @btnClicked="select" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "reskhazard-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        ramRiskHazardClassCd: null,
        riskHazardName: "",
        useFlag: "Y",
      },
      grid: {
        columns: [
          {
            name: "ramRiskHazardClassName",
            field: "ramRiskHazardClassName",
            label: "유해위험요인 분류",
            align: "center",
            sortable: true,
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            label: "유해위험요인명",
            align: "center",
            sortable: true,
          },
        ],
        height: "500px",
        data: [],
      },
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height =
        this.contentHeight - this.$refs["searchbox"].$el.offsetHeight - 50;
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + "px";
    },
  },
  methods: {
    init() {
      this.listUrl = selectConfig.ram.riskHazard.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내", // 안내
          message: "유해위험요인을 선택하세요.", // 유해위험요인을 선택하세요
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
  },
};
</script>
